/*
 * Created by Alvin Julian on Tue Apr 30 2019
 *
 * Copyright (c) 2019 Alvin Julian
 * 
 * Store.jsx - Redux Store
 * 
 */

import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import promise from 'redux-promise-middleware';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import rootReducer from './reducers/index.jsx';

const middleware = composeWithDevTools(applyMiddleware(promise(), thunk));

export default createStore(rootReducer, middleware);


// WEBPACK FOOTER //
// ./src/redux/store.jsx